import { InjectionToken } from '@angular/core';

export const NAVIGATION_PROXY_URL = new InjectionToken<string>('Navigation Proxy Url');
